import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';
import { ProgramsContainer } from 'src/containers/programs';
import { Helmet } from 'react-helmet';
import useSettings from '../../hooks/useSettings';

const Programs = () => {
  const { t } = useTranslation();
  const { settings } = useSettings();
  return (
    <>
      <Helmet>
        <title>{t('programs.helmet')}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4
        }}
      >
        <Container maxWidth={settings.compact ? 'xxl' : false}>
          <Box sx={{ mt: 3 }}>
            <ProgramsContainer />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Programs;
